'use client'

import { DarkModeToggle, MorphoLogo } from '@repo/ui'
import { ConnectWallet } from '@repo/web3'

export function AppNav() {
  return (
    <div className="flex h-16 w-full items-center justify-between p-4">
      <MorphoLogo />
      <div className="flex items-center gap-3">
        <DarkModeToggle />
        <ConnectWallet />
      </div>
    </div>
  )
}
